import { render, staticRenderFns } from "./TXYXAllianceAuthorization.vue?vue&type=template&id=e15913b0"
import script from "./TXYXAllianceAuthorization.vue?vue&type=script&lang=js"
export * from "./TXYXAllianceAuthorization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e15913b0')) {
      api.createRecord('e15913b0', component.options)
    } else {
      api.reload('e15913b0', component.options)
    }
    module.hot.accept("./TXYXAllianceAuthorization.vue?vue&type=template&id=e15913b0", function () {
      api.rerender('e15913b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/allianceAuthorization/TXYXAllianceAuthorization.vue"
export default component.exports